module.exports = __webpack_public_path__ + "f1ea8b127ae7c1fa36e8609fbb2b48ed.png";